/* ===========================================================================
   The Rich Beard · entrada por scroll de Journal, artículo, carrito y búsqueda.

   Mismo comportamiento que components/Reveal.tsx de la vista previa:
   IntersectionObserver con -8% abajo, y un temporizador de seguridad de 2,5 s
   para que nada se quede en blanco si el observador no dispara.
   El retardo de cada elemento va en style="--trb-rv-d: 70ms".
=========================================================================== */
(function () {
  function revelar() {
    var items = document.querySelectorAll('.trb-rv:not(.is-in)');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (n) { n.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    items.forEach(function (n) { io.observe(n); });
    window.setTimeout(function () {
      items.forEach(function (n) { n.classList.add('is-in'); });
    }, 2500);
  }
  window.trbRevelar = revelar;
  document.addEventListener('DOMContentLoaded', revelar);
  document.addEventListener('shopify:section:load', revelar);
  revelar();
})();
